const baseUrl = "PassportSignature";
export const updatePassportUrl = () => `${baseUrl}/UploadPassport`;
export const updateSignatureUrl = () => `${baseUrl}/UploadSignature`;
